import { Routes } from '@angular/router';
import { CookieSettingsGuard } from '@teamfoster/sdk/cookie-ngrx';
import { DictionaryGuard } from '@teamfoster/sdk/dictionary-ngrx';
import { ContentPagesGuard } from './content/guards';
import { DiseaseProfilesGuard } from './disease-profiles/guards';
import { SettingsGuard } from './settings/guards';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home/home.routes').then(m => m.routes),
    pathMatch: 'full',
    canActivate: [DictionaryGuard, SettingsGuard, ContentPagesGuard, CookieSettingsGuard],
    data: {
      breadcrumb: {
        skip: true,
      },
    },
  },
  {
    path: 'stofwisselingsziekten',
    loadChildren: () => import('./disease-profiles/disease-profiles.routes').then(m => m.routes),
    canActivate: [DictionaryGuard, ContentPagesGuard, SettingsGuard, CookieSettingsGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    data: {
      breadcrumb: {
        label: 'Stofwisselingsziekten',
      },
    },
  },
  {
    path: 'styleguide',
    loadChildren: () => import('./style-guide/style-guide.routes').then(m => m.routes),
    data: {
      breadcrumb: {
        label: 'Styleguide',
      },
    },
  },
  {
    path: 'word-lid-of-donateur',
    loadChildren: () => import('./member-form/member-form.routes').then(m => m.routes),
    canActivate: [DictionaryGuard, SettingsGuard, ContentPagesGuard, CookieSettingsGuard],
  },
  {
    path: 'pagina',
    loadChildren: () =>
      import('./content/content.routes').then(m =>
        m.createContentRoutes('pagina', () =>
          import('./content/containers/content-page-detail/content-page-detail.component').then(c => c.ContentPageDetailComponent)
        )
      ),
    canActivate: [DictionaryGuard, SettingsGuard, ContentPagesGuard, DiseaseProfilesGuard, CookieSettingsGuard],
    data: {
      breadcrumb: {
        label: 'pagina',
      },
    },
  },
  {
    path: 'evenementen',
    loadChildren: () =>
      import('./content/content.routes').then(m =>
        m.createContentRoutes('evenementen', () =>
          import('./content/containers/event-detail/event-detail.component').then(c => c.EventDetailComponent)
        )
      ),
    canActivate: [DictionaryGuard, SettingsGuard, ContentPagesGuard, DiseaseProfilesGuard, CookieSettingsGuard],
    data: {
      breadcrumb: {
        label: 'evenementen',
      },
    },
  },
  {
    path: 'nieuws',
    loadChildren: () =>
      import('./content/content.routes').then(m =>
        m.createContentRoutes('nieuws', () => import('./content/containers/news-detail/news-detail.component').then(c => c.NewsDetailComponent))
      ),
    canActivate: [DictionaryGuard, SettingsGuard, ContentPagesGuard, DiseaseProfilesGuard, CookieSettingsGuard],
    data: {
      breadcrumb: {
        label: 'nieuws',
      },
    },
  },
  {
    path: 'blogs',
    loadChildren: () =>
      import('./content/content.routes').then(m =>
        m.createContentRoutes('blogs', () => import('./blogs/containers/blog-detail/blog-detail.component').then(c => c.BlogDetailComponent))
      ),
    canActivate: [DictionaryGuard, SettingsGuard, ContentPagesGuard, DiseaseProfilesGuard, CookieSettingsGuard],
    data: {
      breadcrumb: {
        label: 'blogs',
      },
    },
  },
  {
    path: '404',
    loadComponent: () => import('./404.component').then(m => m.NotFoundComponent),
    canActivate: [DictionaryGuard, CookieSettingsGuard],
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];
